import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Form, Button, Row, Col } from 'react-bootstrap';
import { Formik, Field, Form as FormikForm, FieldArray, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import CreatableSelect from 'react-select/creatable';
import moment from 'moment';
import 'bootstrap/dist/css/bootstrap.min.css';
import PageTitle from '../../../layouts/PageTitle';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import './MultiSelect.css';
import { connect, useDispatch } from 'react-redux';
import { getJobTitleList } from '../../../../store/selectors/JobSelectors';
import { jobTitleListAction } from '../../../../store/actions/JobActions';
import { getContractLocationsAction } from '../../../../store/actions/ContractLocationActions';
import { employeeSearchAction } from '../../../../store/actions/BoxActions';
import { employeeSearchList } from '../../../../store/selectors/BoxSelectors';
import { getProfile } from '../../../../store/selectors/AuthSelectors';
import {
  getBoxAuthToken,
  getBoxAuthUrl,
  getUsersSearch,
  uploadFileBatch,
} from '../../../../services/BoxService';
import { storeData } from '../../../../services/indexedDBUtils';
import { getJobById } from '../../../../services/JobService';
import { getFacilityBuildingRoomsList } from '../../../../services/FacilityBuildingRoomService';
import { getBoxFolderOfEmpByEmail } from '../../../../services/BoxFolderOfEmpService';
import { getMTEByEmail } from '../../../../services/MTEService';
import Swal from 'sweetalert2';
import Cookies from 'js-cookie';

import { createFormAction } from '../../../../store/actions/FormsActions';
import { retrieveData } from '../../../../services/indexedDBUtils';
import { useAuth } from '../../../../context/authContext';
import PPEField from './PPEField';
import { useLoader } from '../../../../context/LoaderCotext';
const JobHazar = ({ jobTitleList, employeeList, profile }) => {
  const validationSchema = Yup.object({
    forms: Yup.array().of(
      Yup.object().shape({
        employee: Yup.object().required('Employee is required'),
        email: Yup.string().email('Invalid email').required('Email is required'),
        date: Yup.date().required('Date is required'),
        jobType: Yup.array()
          .of(Yup.string().required('Job type is required'))
          .min(1, 'At least one job type is required')
          .required('Job type is required'),
        facility: Yup.string().required('Facility is required'),
        manager: Yup.string().required('Manager is required'),
        contract: Yup.string().required('Contract is required'),
        submitter: Yup.string().required('Form submitter is required'),
      })
    ),
  });

  const initialValues = {
    forms: [
      {
        employee: '',
        email: '',
        date: moment().toDate(),
        jobType: '',
        facility: '',
        manager: '',
        ppe: [],
        contractType: '',
        contract: '',
        submitter: profile ? profile.firstName + ' ' + profile.lastName : '',
        hazards: [],
        boxFolderId: '0',
        boxFolderName: 'JHA-Forms',
        timestamp: moment().unix(),
      },
    ],
  };
  const [facilityList, setFacilityList] = useState([]);
  const [folderAPISuccess, setFolderAPISuccess] = useState(false);
  const [cookieValue, setCookieValue] = useState(Cookies.get('boxToken'));
  const { hasPermission } = useAuth();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const { showLoader, hideLoader } = useLoader();
  useEffect(() => {
    dispatch(jobTitleListAction());
    dispatch(getContractLocationsAction());
    dispatch(employeeSearchAction(''));
    const getFacilityList = async () => {
      const fList = await getFacilityBuildingRoomsList();
      setFacilityList(fList || []);
    };
    getFacilityList();
  }, []);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const authCode = searchParams.get('code');
    const apiCall = async () => {
      if (typeof authCode != 'undefined' && authCode != '' && authCode != null) {
        await getBoxAuthToken(authCode)
          .then(async (response) => {
            if (typeof response.data.key != 'undefined') {
              const expiryDate = new Date();
              expiryDate.setTime(expiryDate.getTime() + response.data.life * 1000);
              Cookies.set('boxToken', response.data.key, {
                expires: expiryDate,
                path: '/',
                secure: true,
              });
              setCookieValue(Cookies.get('boxToken'));
              setFolderAPISuccess(true);
            }
          })
          .catch(async (error) => {});
      } else {
        setFolderAPISuccess(true);
      }
    };
    if (typeof cookieValue == 'undefined' && hasPermission('box-folders', ['show']) == true) {
      apiCall();
    } else {
      setFolderAPISuccess(true);
    }
  }, [cookieValue]);

  const [hasDashboardMenu, setHasDashboardMenu] = useState(true);
  useEffect(() => {
    if (profile && profile.allowedModules) {
      const hasDashboard = profile.allowedModules.some(
        (module) => module.value.trim() === 'dashboard' && module.operations.includes('menu')
      );
      if (hasDashboard == false) {
        setHasDashboardMenu(false);
      }
    }
  }, [profile]);

  const loadOptions = (inputValue, callback) => {
    if (!inputValue) {
      callback([]);
      return;
    }
    getUsersSearch(inputValue)
      .then((response) => {
        const options = response.data.map((employee) => ({
          value: employee.displayName || `${employee.firstName} ${employee.lastName}`,
          label: employee.displayName || `${employee.firstName} ${employee.lastName}`,
          email: employee.email,
        }));
        callback(options);
      })
      .catch((error) => {
        console.error('Error fetching employee data', error);
        callback([]);
      });
  };

  const handleCopy = (values, setFieldValue, push) => {
    const lastIndex = values.forms.length - 1;
    const lastRow = values.forms[lastIndex];

    const newRow = {
      ...lastRow,
      employee: '',
      email: '',
      manager: '',
      contract: '',
    };

    push(newRow);
  };

  const handleUploadBatch = async (forms) => {
    const payload = {
      submitterName: profile.firstName + ' ' + profile.lastName,
      submitterEmail: profile.email,
      status: 'in progress',
      formType: 'jha-form',
      contractor: 'ssai',
      dynamicFields: forms,
    };
    if (
      localStorage.getItem('formDataJSON') == null ||
      typeof localStorage.getItem('formDataJSON') == 'undefined'
    ) {
      localStorage.setItem('formDataJSON', await storeData(payload));
    }

    const formData = await retrieveData(parseInt(localStorage.getItem('formDataJSON')));

    if (formData) {
      const payload = {
        data: formData.dynamicFields,
        key: cookieValue || '',
        isBoxExplorer: hasPermission('box-folders', ['show']) || false,
      };
      try {
        showLoader();
        const response = await uploadFileBatch(payload);
        if (Array.isArray(formData.dynamicFields)) {
          formData.dynamicFields.forEach((data, index) => {
            if (index == formData.dynamicFields - 1) {
              dispatch(createFormAction({ ...formData, ['dynamicFields']: data }, navigate));
            } else {
              dispatch(createFormAction({ ...formData, ['dynamicFields']: data }, undefined));
            }
          });
        } else {
          hasDashboardMenu == true ? navigate('/dashboard') : navigate('/forms');
        }

        Swal.fire({
          icon: 'success',
          title: 'Request submitted',
          text: 'Your request is submitted please wait for approver',
          width: 400,
          height: 400,
          confirmButtonColor: '#3a7afe',
        }).then(() => {
          hasDashboardMenu == true ? navigate('/dashboard') : navigate('/forms');
        });
      } catch (error) {
        if (
          typeof error.response != 'undefined' &&
          typeof error.response.status != 'undefined' &&
          error.response.status == '501'
        ) {
          Swal.fire({
            icon: 'error',
            title: 'Employee Data Error',
            text: 'Employee data not exist on box, Please contact your admin',
            width: 400,
            height: 400,
            confirmButtonColor: '#3a7afe',
          });
          hasDashboardMenu == true ? navigate('/dashboard') : navigate('/forms');
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Request not submitted',
            text: 'Please contact your admin',
            width: 400,
            height: 400,
            confirmButtonColor: '#3a7afe',
          });
          console.error(
            'Error uploading file:',
            error.response ? error.response.data : error.message
          );
        }
      } finally {
        hideLoader();
      }
    } else {
      Swal.fire({
        icon: 'error',
        title: 'Form is empty',
        text: 'Please contact your admin',
        width: 400,
        height: 400,
        confirmButtonColor: '#3a7afe',
      });
      hasDashboardMenu == true ? navigate('/dashboard') : navigate('/forms');
    }
  };

  const handleSubmit = (data) => {
    if (typeof data != 'undefined' && typeof data.forms != 'undefined' && data.forms.length > 0) {
      const payloadForms = data.forms.map((form) => {
        return { ...form, employee: form.employee.value };
      });
      handleUploadBatch(payloadForms);
    }
  };

  const handleTypeChange = async (index, selectedOptions, setFieldValue) => {
    const ppeArray = [];
    const hazardsArray = [];

    for (let option of selectedOptions) {
      const response = await getJobById(option.id);
      if (response.ppe && !['none', 'null'].includes(response.ppe.toLowerCase())) {
        ppeArray.push(response.ppe || 'NA');
      }
      hazardsArray.push(response.hazards);
    }

    const ppe = ppeArray.length > 0 ? ppeArray : ['NA'];
    const hazards = hazardsArray.length > 0 ? hazardsArray : [];

    await setFieldValue(
      `forms[${index}].jobType`,
      selectedOptions.map((option) => option.value)
    );
    await setFieldValue(`forms[${index}].ppe`, ppe);
    await setFieldValue(`forms[${index}].hazards`, hazards);
  };

  const handleEmployeeChange = async (index, selectedOption, setFieldValue) => {
    const folderIdRes = await getBoxFolderOfEmpByEmail(selectedOption.email);
    if (typeof folderIdRes.isError != 'undefined' && folderIdRes.isError == true) {
      Swal.fire({
        icon: 'error',
        title: 'Employee Data Error',
        text: 'Employee data not configured with box, Please contact your admin',
        width: 400,
        height: 400,
        confirmButtonColor: '#3a7afe',
      });
      setFieldValue(`forms[${index}].email`, '');
      setFieldValue(`forms[${index}].manager`, '');
      setFieldValue(`forms[${index}].contract`, '');
      setFieldValue(`forms[${index}].boxFolderId`, '');
      return false;
    }
    const getManager = await getMTEByEmail(selectedOption.email);
    if (
      typeof getManager != 'undefined' &&
      typeof getManager.contract != 'undefined' &&
      getManager.contract != '' &&
      getManager.contract.toLowerCase() != profile.contract.toLowerCase() &&
      profile.role.toLowerCase() !== 'admin'
    ) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'You are not accosiated with selected employee contract, please select correct employee and contract',
        width: 400,
        height: 400,
        confirmButtonColor: '#3a7afe',
      });
      setFieldValue(`forms[${index}].email`, '');
      setFieldValue(`forms[${index}].manager`, '');
      setFieldValue(`forms[${index}].contract`, '');
      setFieldValue(`forms[${index}].boxFolderId`, '');
      return false;
    }
    setFieldValue(`forms[${index}].manager`, getManager.manager || 'Not assigned');
    setFieldValue(`forms[${index}].contract`, getManager.contract || 'All');
    setFieldValue(`forms[${index}].boxFolderId`, folderIdRes.folderId || '0');
    setFieldValue(`forms[${index}].email`, selectedOption.email);
  };

  return (
    <>
      <PageTitle pageTitle="JHA Form" />
      <div className="form-container" style={{ padding: '1rem 2rem 2rem 2rem' }}>
        <div
          className="d-flex justify-content-end"
          style={{ fontSize: '14px', fontWeight: '600', paddingBottom: '10px' }}
        >
          <Link
            className="mb-2 text-primary"
            target="_blank"
            to="https://ssaihq.app.box.com/file/1660213775954"
          >
            Instruction to Submit the JHA form
          </Link>
        </div>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ values, setFieldValue }) => (
            <FormikForm>
              <FieldArray name="forms">
                {({ push, remove }) => (
                  <>
                    {values.forms.map((form, index) => (
                      <div key={index} className="mb-4 border-bottom pb-3">
                        <Row className="mb-3">
                          <Col>
                            <Form.Group>
                              <Form.Label>Employee Name</Form.Label>
                              <AsyncSelect
                                cacheOptions
                                placeholder="Select employee..."
                                loadOptions={loadOptions}
                                defaultOptions={employeeList}
                                onChange={(option) => {
                                  setFieldValue(`forms[${index}].employee`, option);
                                  handleEmployeeChange(index, option, setFieldValue);
                                }}
                                value={form.employee}
                              />
                              <ErrorMessage
                                name={`forms[${index}].employee`}
                                component="div"
                                className="text-danger"
                              />
                            </Form.Group>
                          </Col>
                          <Col>
                            <Form.Group>
                              <Form.Label>Manager Name</Form.Label>
                              <Field
                                as={Form.Control}
                                name={`forms[${index}].manager`}
                                placeholder="Enter manager"
                                readOnly
                              />
                              <ErrorMessage
                                name={`forms[${index}].manager`}
                                component="div"
                                className="text-danger"
                              />
                            </Form.Group>
                          </Col>
                          <Col>
                            <Form.Group>
                              <Form.Label>Facility/Building/Room</Form.Label>
                              <CreatableSelect
                                options={facilityList}
                                value={facilityList.find((e) => e.value === form.facility)}
                                placeholder="Select or Create Facility..."
                                onChange={(option) =>
                                  setFieldValue(`forms[${index}].facility`, option.value)
                                }
                                onCreateOption={(newValue) => {
                                  // Optionally handle new value creation
                                  const newOption = {
                                    value: newValue,
                                    label: newValue,
                                  };
                                  facilityList.push(newOption); // Add the new option to your facilityList array
                                  setFieldValue(`forms[${index}].facility`, newOption.value); // Set the newly created value
                                }}
                              />
                              <ErrorMessage
                                name={`forms[${index}].facility`}
                                component="div"
                                className="text-danger"
                              />
                            </Form.Group>
                          </Col>
                          <Col>
                            <Form.Group>
                              <Form.Label>Form Submitter</Form.Label>
                              <Field
                                as={Form.Control}
                                value={profile ? profile.firstName + ' ' + profile.lastName : ''}
                                name={`forms[${index}].submitter`}
                                placeholder="Form Submitter"
                                readOnly
                              />
                              <ErrorMessage
                                name={`forms[${index}].submitter`}
                                component="div"
                                className="text-danger"
                              />
                            </Form.Group>
                          </Col>
                        </Row>
                        <Row className="mb-3">
                          <Col>
                            <Form.Group>
                              <Form.Label>Date</Form.Label>
                              <DatePicker
                                name={`forms[${index}].date`}
                                as={Form.Control}
                                selected={form.date}
                                onChange={async (date) =>
                                  await setFieldValue(`forms[${index}].date`, date)
                                }
                                showYearDropdown
                                yearDropdownItemNumber={15}
                                scrollableYearDropdown
                                minDate={new Date()}
                                placeholderText="MM-DD-YYYY"
                                className="form-control"
                              />
                              <ErrorMessage
                                name={`forms[${index}].date`}
                                component="div"
                                className="text-danger"
                              />
                            </Form.Group>
                          </Col>
                          <Col>
                            <Form.Group>
                              <Form.Label>Contract</Form.Label>
                              <Field
                                as={Form.Control}
                                name={`forms[${index}].contract`}
                                placeholder="Enter contract"
                                readOnly
                              />
                              <ErrorMessage
                                name={`forms[${index}].contract`}
                                component="div"
                                className="text-danger"
                              />
                            </Form.Group>
                          </Col>
                          <Col>
                            <Form.Group>
                              <Form.Label>Job Type</Form.Label>
                              <Select
                                as={Form.Control}
                                name={`forms[${index}].jobType`}
                                isMulti
                                value={jobTitleList.filter((e) => form.jobType.includes(e.value))}
                                options={jobTitleList}
                                placeholder="Select Job type..."
                                className={`react-select-container`}
                                classNamePrefix="react-select"
                                styles={{
                                  control: (base) => ({
                                    ...base,
                                    width: '100%', // Ensure it takes up full width of its container
                                    maxWidth: '300px', // Set a maximum width (or adjust as needed)
                                    minWidth: '200px', // Set a minimum width for responsiveness
                                  }),
                                }}
                                onChange={(selectedOptions) => {
                                  handleTypeChange(index, selectedOptions, setFieldValue);
                                }}
                              />
                              <ErrorMessage
                                name={`forms[${index}].jobType`}
                                component="div"
                                className="text-danger"
                              />
                            </Form.Group>
                          </Col>
                          <Col>
                            <PPEField
                              relativeFieldValue={form.jobType}
                              index={index}
                              values={values}
                              setFieldValue={setFieldValue}
                            />
                          </Col>
                        </Row>
                        {values.forms.length > 1 ? (
                          <Row>
                            <Col className="d-flex justify-content-end">
                              <Button
                                key={index}
                                variant="danger"
                                onClick={() => remove(index)}
                                className="mb-3"
                                disabled={values.forms.length === 1}
                              >
                                <i className="fa fa-trash"></i>
                              </Button>
                            </Col>
                          </Row>
                        ) : (
                          ''
                        )}
                      </div>
                    ))}
                    <Row>
                      <Col className="d-flex justify-content-end">
                        <Button
                          style={{ margin: '2px' }}
                          variant="primary"
                          onClick={() =>
                            push({
                              employee: '',
                              email: '',
                              date: moment().toDate(),
                              jobType: '',
                              facility: '',
                              manager: '',
                              ppe: [],
                              contractType: '',
                              contract: '',
                              submitter: profile ? profile.firstName + ' ' + profile.lastName : '',
                              hazards: [],
                              boxFolderId: '0',
                              boxFolderName: 'JHA-Forms',
                              timestamp: moment().unix(),
                            })
                          }
                        >
                          Add
                        </Button>
                        <Button
                          style={{ margin: '2px' }}
                          variant="primary"
                          onClick={() => handleCopy(values, setFieldValue, push)}
                        >
                          Copy
                        </Button>
                        <Button type="submit" style={{ margin: '2px' }}>
                          Submit
                        </Button>
                      </Col>
                    </Row>
                  </>
                )}
              </FieldArray>
            </FormikForm>
          )}
        </Formik>
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  jobTitleList: getJobTitleList(state),
  employeeList: employeeSearchList(state),
  profile: getProfile(state),
});
export default connect(mapStateToProps)(JobHazar);
